import { CustomModelEditorContext } from "@custom-model-editor/custom-model-editor-context.tsx";
import { useContext } from "react";

export const useCustomModelEditorContext = () =>
  useContext(CustomModelEditorContext);
